import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appHrefExternalUrl]'
})
export class HrefExternalUrlDirective {

  constructor(
    private elementRef: ElementRef<HTMLAnchorElement>
  ) { }

  @HostListener('click', ['$event']) onClick(event: MouseEvent) {
    event.preventDefault();
    let url: string = (<any>event.currentTarget).getAttribute('href');
    if (url && url.indexOf('http') < 0) {
      url = `//${url}`;
    } else {
      url = `${url}`;
    }
    window.open(url, '_blank');
  }
}
